import axios from 'axios'
import { STORE_URL } from './api'
import { authorizationHelper } from '../common/helpers'

export function getAll(page, filter) {

    const params = {
        page,
        filter
    }

    return axios.get(STORE_URL, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function get(id) {
    const url = `${STORE_URL}/${id}`

    return axios.get(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function create(store) {
    return axios.post(STORE_URL, store, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function update(id, store) {
    const url = `${STORE_URL}/${id}`

    return axios.put(url, store, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function deleteStore(id) {
    const url = `${STORE_URL}/${id}`

    return axios.delete(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}


// WEBPACK FOOTER //
// ./src/service/store.js